import { ProductListWUT } from '@wix/form-fields/wut';

export default ProductListWUT;
